import React from 'react';
import { lifestyleData } from '../data/mock';

export const Lifestyle = () => {
  return (
    <section id="lifestyle" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
              {lifestyleData.title}
            </h2>
            <p className="text-lg text-charcoal-400 max-w-3xl mx-auto leading-relaxed">
              {lifestyleData.description}
            </p>
          </div>

          {/* Image Grid */}
          <div className="grid md:grid-cols-3 gap-6">
            {lifestyleData.images.map((image, index) => (
              <div
                key={index}
                className="relative group overflow-hidden rounded-2xl aspect-[4/5] shadow-lg"
              >
                <img
                  src={image}
                  alt={`Lifestyle ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            ))}
          </div>

          {/* Bottom Text */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-gold-50 rounded-2xl px-8 py-6 border border-gold-100">
              <p className="text-charcoal text-lg font-medium">
                Every home at Assetree is designed to be a canvas for your life's most precious moments
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
